import React, { useContext } from "react";
import styled from "styled-components";

import { Cartesian } from "@examspark/types";

import { Text } from "../cartesian/Text";
import { useCartesianDrag } from "../cartesian/useDrag";
import {
  CartesianGraphContext,
  applyOffsetToCoordinate,
  getImageCoordsFromCartesianCoords,
} from "../cartesian/utils";

const Bar = styled.rect`
  fill: #1fa4e1;
  transition: fill 0.2s;
`;

const BarHandle = styled.rect`
  fill: #333;
  opacity: 0;
  transition: opacity 0.2s;
`;

const InvisibleBarHandle = styled.rect`
  fill: yellow;
  cursor: grab;
  opacity: 0;

  &:hover {
  }
`;

const Group = styled.g`
  &:hover {
    ${Bar} {
      fill: #6dc4ec;
    }
    ${BarHandle} {
      opacity: 1;
    }
  }
`;
interface Props {
  position: number;
  label?: string;
  value: number;
  width: number;
  onChange?: (coord: Cartesian.Coordinate) => void;
}

const BarChartBar: React.FC<React.PropsWithChildren<Props>> = (props) => {
  const graph = useContext(CartesianGraphContext);
  const drag = useCartesianDrag(
    graph?.canvas || null,
    { x: props.position + 1, y: props.value },
    {
      snapToGrid: true,
      restrictDragAxis: "y",
      onDragEnd: (c: Cartesian.Coordinate) => {
        // console.log("drag end!");
        props.onChange?.(c);
      },
      onDrag: (c: Cartesian.Coordinate) => {
        // console.log("drag start...", c);
      },
    },
  );

  /** higher y value */
  const baseCoord = getImageCoordsFromCartesianCoords(graph!.graph, {
    x: 0,
    y: 0,
  });
  /** lower x value */
  const valueCoord = getImageCoordsFromCartesianCoords(
    graph!.graph,
    drag.coord,
  );

  // console.log("base/value", baseCoord, valueCoord);

  const imgCoord = getImageCoordsFromCartesianCoords(
    graph!.graph,
    {
      ...drag.coord,
      y: 0,
    },
    {
      x: -(props.width / 2),
      y: valueCoord.y - baseCoord.y,
    },
  );

  const handleCoord = getImageCoordsFromCartesianCoords(
    graph!.graph,
    drag.coord,
    {
      x: -(props.width / 2),
      y: 0,
    },
  );

  const posLabel = getImageCoordsFromCartesianCoords(
    graph!.graph,
    {
      ...drag.coord,
      y: 0,
    },
    {
      x: 0,
      y: 20,
    },
  );

  return (
    <>
      <Group>
        <Bar
          height={baseCoord.y - valueCoord.y}
          width={props.width}
          {...imgCoord}
        />
        <BarHandle
          height="3.5"
          width={props.width}
          {...applyOffsetToCoordinate(handleCoord, { x: 0, y: 0 })}
        />
        <InvisibleBarHandle
          height="50"
          width={props.width}
          {...applyOffsetToCoordinate(handleCoord, {
            x: 0,
            y: -(50 / 2),
          })}
          onMouseDown={(e) => {
            drag?.startDrag?.(e);
            // props.onDragStart?.();
          }}
          onMouseUp={(e) => {
            drag?.stopDrag?.(e);
          }}
        />
      </Group>
      {props.label && (
        <Text coords={posLabel} anchor="middle">
          {props.label}
        </Text>
      )}
    </>
  );
};

export default BarChartBar;
